<script lang="ts" setup>
import { useSwiper } from '~/composables/common/use-swiper'

const { Swiper, SwiperSlide, modules } = useSwiper()
defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
  items: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    type: Array as PropType<any[]>,
    default: () => [],
  },
  onSwiper: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    type: Function as PropType<(swiper: any) => void>,
    default: () => {},
  },
  itemSlidesPerView: {
    type: Number,
    default: 0,
  },
})
</script>
<template>
  <div class="base-swiper">
    <Swiper :modules="modules" v-bind="options" @swiper="onSwiper">
      <SwiperSlide v-for="(item, index) in items" :key="index">
        <slot name="item" :item="item" :index="index" />
      </SwiperSlide>
    </Swiper>
    <div v-show="items?.length > itemSlidesPerView">
      <div
        v-if="options.navigation"
        class="base-swiper__prev icon-left custom-swiper-prev"
        :class="options.navigation?.prevEl?.replace('.', '')"
      />
      <div
        v-if="options.navigation"
        class="base-swiper__next icon-right custom-swiper-next"
        :class="options.navigation?.nextEl?.replace('.', '')"
      />
    </div>
  </div>
</template>
